import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/useUserServicePostHook";
import useGetHook from "../../customHooks/useUserServiceGetHook";

const CreateRoleComponent = loadable(
  () => import("../../components/Auth/CreateRole")
);
const CreateRole = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["roles"],
    navigateURL: "/roles",
  });

  const { data:userPermissions } = useGetHook({
    queryKey: [`userPermissions`],
    url: `${APIS.PERMISSIONS}user_management/`,
    params: {},
  });

  const { data:logesticPermissions } = useGetHook({
    queryKey: [`logesticPermissions`],
    url: `${APIS.PERMISSIONS}logistic/`,
    params: {},
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.GROUP}`;
    let formData = {
      ...values
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Role</span>
      </div>
      <CreateRoleComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        userPermissions={userPermissions}
        logesticPermissions={logesticPermissions}
      />
    </>
  );
};

export default CreateRole;
